/* global videojs */

import PerfectScrollbar from 'perfect-scrollbar';
import Swiper from 'swiper/dist/js/swiper.min';

$('.article').each((index, element) => {
	let $component = $(element);
	let $page = $component.closest('.page');
	let $head = $component.find('.js-article-head');
	let $content = $component.find('.js-article-content');
	let $textBlock = $content.find('.js-article-text-block');
	let $scrolledContent = $content.find('.js-article-scroll-content');
	let $video = $component.find('.js-video');
	let $slider = $component.find('.js-article-slider');
	let $mobileSlider = $component.find('.js-article-text-slider');
	let $slide = $component.find('.js-article-slide');
	let $popup = $page.find('.popup');
	let $slidePrev = $component.find('.js-slide-prev');
	let $slideNext = $component.find('.js-slide-next');
	let $backLink = $component.find('.article__back-link, .article__head-title');
	let $tabList = $component.find('.article__tab');
	let $tabPaneContainer = $component.find('.article__tab-panes');
	let $tabPaneList = $component.find('.article__tab-pane');
	let $sliderTitle = $component.find('.article__slider-title--slidelist');
	let $mainPage = $component.closest('.page[data-page="home"]');
	let $header = $mainPage.find('.js-header');
	let $footer = $mainPage.find('.js-footer');
	let ps = null;
	let tabTimeout = null;

	$mobileSlider.each((idx, elem) => {
		let mobileSlider = new Swiper($(elem)[0], {
			slidesPerView: 1,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true,
			},
		});

		function sliderUpdate() {
			if ($(window).innerWidth() < 1025) {
				mobileSlider.update();
			}
		}

		$page.on('page:show', () => {
			sliderUpdate();
		});

		$component.on('mobile-slider:update', () => {
			setTimeout(() => {
				sliderUpdate();
			}, 300);
		});

		$(window).on('resize', () => {
			sliderUpdate();
		});
	});

	function calcContentHeight() {
		if ($(window).innerWidth() > 1024) {
			$content.css({
				height: `${$component.outerHeight() - $head.outerHeight()}px`,
			});

			$textBlock.css({
				height: `${$content.height()}px`,
			});

			$scrolledContent.css({
				height: $textBlock.height() -
					// eslint-disable-next-line radix
					(parseInt($tabPaneContainer.css('margin-bottom')) + $tabPaneContainer.outerHeight()),
			});

			if (!ps) {
				ps = new PerfectScrollbar($scrolledContent[0], {
					wheelSpeed: 1,
					wheelPropagation: true,
					minScrollbarLength: 20,
				});
			}
		} else {
			if (ps) {
				ps.destroy();
				ps = null;
			}
			$content.attr('style', '');
			$textBlock.attr('style', '');
			$scrolledContent.attr('style', '');
		}
	}

	calcContentHeight();

	$(window).on('resize', () => {
		calcContentHeight();
	});

	$page.on('page:show', () => {
		calcContentHeight();
	});

	$backLink.on('click', () => {
		$('.js-main-popup').fadeOut(0);
		$footer.trigger('footer:show');
		$header.addClass('active');
	});

	$sliderTitle.fadeOut(0);
	$sliderTitle.eq(0).stop(true, true).fadeIn(0);

	$tabPaneList.on('click', (e) => {
		let $element = $(e.currentTarget);

		$component.trigger('mobile-slider:update');

		if (!$element.hasClass('active')) {
			$tabPaneList.removeClass('active');
			$element.addClass('active');
			$tabList.stop(true, true).fadeOut(200).removeClass('active');

			$sliderTitle.stop(true, true).fadeOut(200);

			setTimeout(() => {
				$sliderTitle.eq($element.index()).stop(true, true).fadeIn(200);
			}, 200);

			if (tabTimeout) {
				clearTimeout(tabTimeout);
			}

			tabTimeout = setTimeout(() => {
				$tabList.eq($element.index()).stop(true, true).fadeIn(200).addClass('active');
				setTimeout(() => {
					$scrolledContent[0].scrollTop = 0;

					if (ps) {
						ps.update();
					}
				}, 300);
			}, 200);
		}
	});

	// article analytics
	$scrolledContent.on('ps-y-reach-end', () => {
		ga('send', 'event', 'article', 'scroll bottom');
	});

	function pauseVideo(video) {
		if (!video.paused()) {
			video.pause();
		}
	}

	$video.each((idx, video) => {
		let isStarted = false;
		let articleName = $page.find('.article__title').text();
		let videoName = `видео в статье "${articleName}"`;
		let interval10sec;
		let markerList = null;

		let videoJs = videojs($(video)[0], {
			autoplay: true,
			controls: true,
			muted: true,
			fluid: false,
		});

		if ($page.data('page') === 'article-2') {
			markerList = [
				{
					'time': 54.0,
					'text': 'Тридевятое царство',
					'class': 'custom-marker',
				},
				{
					'time': 167.0,
					'text': 'Родина Алеши Поповича',
					'class': 'custom-marker',
				},
				{
					'time': 235,
					'text': 'Озеро Неро',
					'class': 'custom-marker',
				},
			];
		}

		if ($page.data('page') === 'article-1') {
			markerList = [
				{
					'time': 72.0,
					'text': 'Парк «Кудыкина гора»',
					'class': 'custom-marker',
				},
				{
					'time': 174.0,
					'text': 'Чайный домик',
					'class': 'custom-marker',
				},
				{
					'time': 278.0,
					'text': 'Город мастеров',
					'class': 'custom-marker',
				},
				{
					'time': 304.0,
					'text': 'Змей Горыныч',
					'class': 'custom-marker',
				},
			];
		}

		if ($page.data('page') === 'article-3') {
			markerList = [
				{
					'time': 78.0,
					'text': 'В гостях у Снегурочки',
					'class': 'custom-marker',
				},
				{
					'time': 204.0,
					'text': 'Родина Жар-птицы',
					'class': 'custom-marker',
				},
				{
					'time': 304.0,
					'text': 'Скатерть-самобранка',
					'class': 'custom-marker',
				},
			];
		}

		if (markerList) {
			videoJs.markers({
				markerStyle: {},
				markerTip: {
					display: false,
					text: (marker) => {
						return marker.text;
					},
				},
				onMarkerReached: (marker, id) => {
					$component.find('.custom-marker').eq(id).addClass('active');
				},
				markers: markerList,
			});

			$(window).on('load', () => {
				let markersArr = videoJs.markers.getMarkers();

				setTimeout(() => {
					$.each(markersArr, (id, marker) => {
						let $markerTooltip = $('<div/>', {
							'class': 'custom-marker__tooltip',
							'text': marker.text,
						});

						$component.find('.custom-marker').eq(id).append($markerTooltip);
					});
				}, 1000);
			});
		}

		let $startButton = $component.find('.vjs-big-play-button');

		$startButton.on('click', () => {
			let articleTitle = $page.find('.article__title').text();

			ga('send', 'event', 'article', 'video click', `видео в статье "${articleTitle}"`);
		});

		// popup video analytics
		videoJs.on('play', () => {
			if (!isStarted) {
				isStarted = true;
				ga('send', 'event', 'video', 'play', videoName, {nonInteraction: true});
				ga('rbcspec.send', 'event', 'video', 'play', {nonInteraction: true});
			}

			if (!interval10sec) {
				interval10sec = setInterval(() => {
					if (!video.paused) {
						ga('send', 'event', 'video', 'timing 10s', videoName, 10);
						ga('rbcspec.send', 'event', 'video', 'timing 10s', '', 10);
					}
				}, 10000);
			}
		});

		videoJs.on('pause', () => {
			if (interval10sec) {
				clearInterval(interval10sec);
			}
		});

		videoJs.on('ended', () => {
			ga('send', 'event', 'video', 'finish', videoName);
			ga('rbcspec.send', 'event', 'video', 'finish');

			if (interval10sec) {
				clearInterval(interval10sec);
			}
		});

		$page.on('page:hide', () => {
			pauseVideo(videoJs);
		});
	});

	let slider;

	if ($slider[0] !== undefined) {
		slider = new Swiper($slider[0], {
			slidesPerView: 3,
			spaceBetween: 5,
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true,
			},
		});
	}

	$slidePrev.on('click', () => {
		slider.slidePrev();
	});

	$slideNext.on('click', () => {
		slider.slideNext();
	});

	$slide.on('click', (e) => {
		let slideIndex = $(e.currentTarget).parent().index() + 1;

		$popup.trigger('popup:show');
		$popup.trigger('popup:slide-to', [slideIndex]);
		$component.find('.article__col--slider').addClass('hidden');
		ga('send', 'event', 'article', 'gallery click');
	});

	$page.on('page:show', () => {
		if (ps) {
			ps.update();
		}

		if (slider !== undefined) {
			slider.update();
		}
	});

	$popup.on('popup:hide', () => {
		$component.find('.article__col--slider').removeClass('hidden');
	});
});
